/* eslint-disable */
/** @type {HttpStatus} */
const httpStatus = {
  100: `Continue`,
  101: `Switching Protocols`,
  102: `Processing`,
  103: `Early Hints`,
  200: `OK`,
  201: `Created`,
  202: `Accepted`,
  203: `Non-Authoritative Information`,
  204: `No Content`,
  205: `Reset Content`,
  206: `Partial Content`,
  207: `Multi-Status`,
  208: `Already Reported`,
  226: `IM Used`,
  300: `Multiple Choices`,
  301: `Moved Permanently`,
  302: `Found`,
  303: `See Other`,
  304: `Not Modified`,
  305: `Use Proxy`,
  306: `Switch Proxy`,
  307: `Temporary Redirect`,
  308: `Permanent Redirect`,
  400: `Bad Request`,
  401: `Unauthorized`,
  402: `Payment Required`,
  403: `Forbidden`,
  404: `Not Found`,
  405: `Method Not Allowed`,
  406: `Not Acceptable`,
  407: `Proxy Authentication Required`,
  408: `Request Timeout`,
  409: `Conflict`,
  410: `Gone`,
  411: `Length Required`,
  412: `Precondition Failed`,
  413: `Payload Too Large`,
  414: `URI Too Long`,
  415: `Unsupported Media Type`,
  416: `Range Not Satisfiable`,
  417: `Expectation Failed`,
  418: `I'm a teapot`,
  421: `Misdirected Request`,
  422: `Unprocessable Entity`,
  423: `Locked`,
  424: `Failed Dependency`,
  426: `Upgrade Required`,
  428: `Precondition Required`,
  429: `Too Many Requests`,
  431: `Request Header Fields Too Large`,
  451: `Unavailable For Legal Reasons`,
  500: `Internal Server Error`,
  501: `Not Implemented`,
  502: `Bad Gateway`,
  503: `Service Unavailable`,
  504: `Gateway Timeout`,
  505: `HTTP Version Not Supported`,
  506: `Variant Also Negotiates`,
  507: `Insufficient Storage`,
  508: `Loop Detected`,
  510: `Not Extended`,
  511: `Network Authentication Required`,
  ACCEPTED: 202,
  ALREADY_REPORTED: 208,
  BAD_GATEWAY: 502,
  BAD_REQUEST: 400,
  CONFLICT: 409,
  CONTINUE: 100,
  CREATED: 201,
  EARLY_HINTS: 103,
  EXPECTATION_FAILED: 417,
  FAILED_DEPENDENCY: 424,
  FORBIDDEN: 403,
  FOUND: 302,
  GATEWAY_TIMEOUT: 504,
  GONE: 410,
  HTTP_VERSION_NOT_SUPPORTED: 505,
  IM_A_TEAPOT: 418,
  IM_USED: 226,
  INSUFFICIENT_STORAGE: 507,
  INTERNAL_SERVER_ERROR: 500,
  LENGTH_REQUIRED: 411,
  LOCKED: 423,
  LOOP_DETECTED: 508,
  METHOD_NOT_ALLOWED: 405,
  MISDIRECTED_REQUEST: 421,
  MOVED_PERMANENTLY: 301,
  MULTI_STATUS: 207,
  MULTIPLE_CHOICES: 300,
  NETWORK_AUTHENTICATION_REQUIRED: 511,
  NO_CONTENT: 204,
  NON_AUTHORITATIVE_INFORMATION: 203,
  NOT_ACCEPTABLE: 406,
  NOT_EXTENDED: 510,
  NOT_FOUND: 404,
  NOT_IMPLEMENTED: 501,
  NOT_MODIFIED: 304,
  OK: 200,
  PARTIAL_CONTENT: 206,
  PAYLOAD_TOO_LARGE: 413,
  PAYMENT_REQUIRED: 402,
  PERMANENT_REDIRECT: 308,
  PRECONDITION_FAILED: 412,
  PRECONDITION_REQUIRED: 428,
  PROCESSING: 102,
  PROXY_AUTHENTICATION_REQUIRED: 407,
  RANGE_NOT_SATISFIABLE: 416,
  REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
  REQUEST_TIMEOUT: 408,
  RESET_CONTENT: 205,
  SEE_OTHER: 303,
  SERVICE_UNAVAILABLE: 503,
  SWITCH_PROXY: 306,
  SWITCHING_PROTOCOLS: 101,
  TEMPORARY_REDIRECT: 307,
  TOO_MANY_REQUESTS: 429,
  UNAUTHORIZED: 401,
  UNAVAILABLE_FOR_LEGAL_REASONS: 451,
  UNPROCESSABLE_ENTITY: 422,
  UNSUPPORTED_MEDIA_TYPE: 415,
  UPGRADE_REQUIRED: 426,
  URI_TOO_LONG: 414,
  USE_PROXY: 305,
  VARIANT_ALSO_NEGOTIATES: 506,
};

/** @type {HttpStatus1XXList} */
export const httpStatus1xxList = [httpStatus.CONTINUE, httpStatus.SWITCHING_PROTOCOLS, httpStatus.PROCESSING, httpStatus.EARLY_HINTS];

/** @type {HttpStatus2XXList} */
export const httpStatus2xxList = [
  httpStatus.OK,
  httpStatus.CREATED,
  httpStatus.ACCEPTED,
  httpStatus.NON_AUTHORITATIVE_INFORMATION,
  httpStatus.NO_CONTENT,
  httpStatus.RESET_CONTENT,
  httpStatus.PARTIAL_CONTENT,
  httpStatus.MULTI_STATUS,
  httpStatus.ALREADY_REPORTED,
  httpStatus.IM_USED,
];

/** @type {HttpStatus3XXList} */
export const httpStatus3xxList = [
  httpStatus.MULTIPLE_CHOICES,
  httpStatus.MOVED_PERMANENTLY,
  httpStatus.FOUND,
  httpStatus.SEE_OTHER,
  httpStatus.NOT_MODIFIED,
  httpStatus.USE_PROXY,
  httpStatus.SWITCH_PROXY,
  httpStatus.TEMPORARY_REDIRECT,
  httpStatus.PERMANENT_REDIRECT,
];

/** @type {HttpStatus4XXList} */
export const httpStatus4xxList = [
  httpStatus.BAD_REQUEST,
  httpStatus.UNAUTHORIZED,
  httpStatus.PAYMENT_REQUIRED,
  httpStatus.FORBIDDEN,
  httpStatus.NOT_FOUND,
  httpStatus.METHOD_NOT_ALLOWED,
  httpStatus.NOT_ACCEPTABLE,
  httpStatus.PROXY_AUTHENTICATION_REQUIRED,
  httpStatus.REQUEST_TIMEOUT,
  httpStatus.CONFLICT,
  httpStatus.GONE,
  httpStatus.LENGTH_REQUIRED,
  httpStatus.PRECONDITION_FAILED,
  httpStatus.PAYLOAD_TOO_LARGE,
  httpStatus.URI_TOO_LONG,
  httpStatus.UNSUPPORTED_MEDIA_TYPE,
  httpStatus.RANGE_NOT_SATISFIABLE,
  httpStatus.EXPECTATION_FAILED,
  httpStatus.IM_A_TEAPOT,
  httpStatus.MISDIRECTED_REQUEST,
  httpStatus.UNPROCESSABLE_ENTITY,
  httpStatus.LOCKED,
  httpStatus.FAILED_DEPENDENCY,
  httpStatus.UPGRADE_REQUIRED,
  httpStatus.PRECONDITION_REQUIRED,
  httpStatus.TOO_MANY_REQUESTS,
  httpStatus.REQUEST_HEADER_FIELDS_TOO_LARGE,
  httpStatus.UNAVAILABLE_FOR_LEGAL_REASONS,
];

/** @type {HttpStatus5XXList} */
export const httpStatus5xxList = [
  httpStatus.INTERNAL_SERVER_ERROR,
  httpStatus.NOT_IMPLEMENTED,
  httpStatus.BAD_GATEWAY,
  httpStatus.SERVICE_UNAVAILABLE,
  httpStatus.GATEWAY_TIMEOUT,
  httpStatus.HTTP_VERSION_NOT_SUPPORTED,
  httpStatus.VARIANT_ALSO_NEGOTIATES,
  httpStatus.INSUFFICIENT_STORAGE,
  httpStatus.LOOP_DETECTED,
  httpStatus.NOT_EXTENDED,
  httpStatus.NETWORK_AUTHENTICATION_REQUIRED,
];

export default httpStatus;
